<div>
  <div class="header">
    Cover of <br />
    {{sumAssured | pounds}}
    <a *ngIf="enableEdit" href="javascript:void(0)" (click)="edit.emit(quote)">(edit)</a>
    <br />
    for {{term}} years
  </div>

  <div class="premium">
    <ion-icon name="add"></ion-icon>
    <span>{{premium | pounds}}</span>
    <small>{{premium | appcents}}/month</small>
  </div>

  <label class="valid-until">
    Quote valid until: {{quote.result.validUntil | date:'dd/MM/yyyy'}}
  </label>

  <ion-button (click)="select.emit(quote)" class="app-button">
    <ion-icon name="add"></ion-icon>
    Add
  </ion-button>
</div>